import {
    omit,
} from 'lodash'
import {
    v1 as uuidv1,
} from 'uuid'
import {
    LaneFeesDetail,
} from 'app/Apps/Pricing/Pricing.types'

const prepareDataForCreation = (data: LaneFeesDetail) => {
    const clearedValue: LaneFeesDetail = omit(data, [
        'airlineLogisticPricingId',
        'createdBy',
        'createdOn',
        'laneGroup',
        'laneGroupId',
        'pharmaLeasePricingId',
    ])

    return {
        ...clearedValue,
        fees: clearedValue.fees?.map((fee) => {
            return omit(fee, [
                'id',
                'laneFeesId',
            ])
        }),
        truckingCapacity: clearedValue.truckingCapacity?.map((capacity) => {
            return {
                ...capacity, id: `temp-${uuidv1()}`,
            }
        }),
    }
}

export default prepareDataForCreation
